<template>
  <div class="company-health">
    <div class="company-health-badges">
      <Badge v-if="nafCode" variant="info" size="sm">{{ nafCode }}</Badge>
      <Badge v-if="companySante" :variant="santeVariant" size="sm">
        {{ formatEtatEntreprise(companySante, alertes) }}
      </Badge>
      <Badge v-else-if="showUnknown" variant="secondary" size="sm">Non récupéré</Badge>
      <slot />
    </div>
    <CompanySanteAlertes :alertes="alertes" :siret="siret" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Badge } from '../ui'
import { estActiveSousAlerte, formatEtatEntreprise, getCompanySanteNiveau } from '../../utils/companySante.js'
import CompanySanteAlertes from './CompanySanteAlertes.vue'

const props = defineProps({
  nafCode: { type: String, default: null },
  companySante: { type: String, default: null },
  /** Procédures en cours lues au BODACC : [{ code, libelle, depuis }]. */
  alertes: { type: Array, default: null },
  /** Pour ouvrir la fiche Pappers depuis une alerte. */
  siret: { type: String, default: null },
  showUnknown: { type: Boolean, default: false }
})

/**
 * Ces pastilles passent par le composant Badge du design system : même
 * gabarit (pilule, fond clair, texte de la même teinte, sans bordure ni
 * icône) que les statuts de demande ou les types de client. La palette suit
 * le code couleur de la liste des demandes : orange pour une alerte, rouge
 * pour une entreprise inactive ou un SIRET inexistant.
 */
const VARIANT_PAR_NIVEAU = { alerte: 'warning', danger: 'danger' }

const santeVariant = computed(() => {
  // « Active » s'écrit en vert, comme sur Pappers : l'alerte, dessous, porte l'orange.
  if (props.companySante === 'actif' || estActiveSousAlerte(props.companySante, props.alertes)) return 'success'
  return VARIANT_PAR_NIVEAU[getCompanySanteNiveau(props.companySante)] || 'secondary'
})
</script>

<style scoped>
.company-health {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.company-health-badges {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  flex-wrap: wrap;
}
</style>
